// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"terms-of-use_wrapper__GHk5s","text-page":"terms-of-use_text-page__2jtc7"};